export default () => {
    let appCode: number | undefined;
    let appVersion: number | undefined;
    let appFullVersion: string | undefined;
    let systemRelease: string | undefined;
    let platform: string | undefined;

    if (window.wmSystemApi && window.wmSystemApi.getSystemInfo) {
        // 壳子版本
        if (typeof window.wmSystemApi.getAppInfo === 'function') {
            const appInfo = window.wmSystemApi.getAppInfo();
            appFullVersion = appInfo.version;
            appCode = Number(appInfo.code) || 0;
            appVersion = Number((appInfo.version || '')[0]) || 0;
        }
        // 系统版本
        const systemInfo = window.wmSystemApi.getSystemInfo();
        systemRelease =
            appVersion === 3
                ? `${systemInfo.majorVersion}.${systemInfo.minorVersion}`
                : systemInfo.release;
        platform = systemInfo.platform;
    }

    return { appCode, appVersion, appFullVersion, systemRelease, platform };
};
